import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  id,
  className = ''
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full max-w-xl mx-auto items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] sm:text-xl font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_0_-2px_#127332,0_18px_30px_-10px_rgba(31,163,74,0.55)] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-cta-dark active:translate-y-[3px] active:shadow-[0_6px_0_-2px_#127332,0_10px_20px_-10px_rgba(31,163,74,0.55)] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 ${className}`} data-id="element-11" data-mp="hhj2yzf1lvz3">
      <span data-id="element-12" data-mp="159g9qc3mxxtc">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-13" data-mp="15a9c70vka15o" />
    </a>;
}